import type { ButtonHTMLAttributes } from 'react';
import styled, { css, type DefaultTheme } from 'styled-components';
import { parseDimension } from '../../../styles';
import { FormControlSizes } from '../../Form/types';
import { ButtonWrapper, getButtonVerticalSpacing, getIconButtonSize, type ButtonWrapperProps } from '../styles';

export const getIconFontSize = (theme: DefaultTheme, size: FormControlSizes | number = FormControlSizes.Default) => {
  switch (size) {
    case FormControlSizes.Tiny: {
      return theme.fontSizeSmall;
    }
    case FormControlSizes.Small: {
      return theme.fontSizeDefault;
    }
    case FormControlSizes.Default: {
      return theme.fontSizeLarge;
    }
    case FormControlSizes.Large: {
      return theme.fontSizeBig;
    }
    default: {
      return size - 1;
    }
  }
};

interface IconButtonStyleProps {
  round?: boolean;
  ghost?: boolean;
  size?: FormControlSizes | number;
  width?: string | number;
  height?: string | number;
}

/**
 * Shared styles for icon buttons (both button and link variants)
 */
export const iconButtonStyles = css<IconButtonStyleProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  padding: ${({ theme, size }) => getButtonVerticalSpacing(theme, size)}px;
  border-radius: ${({ round }) => (round ? '100%' : '')};

  & {
    background: ${({ ghost }) => (ghost ? 'transparent' : '')};
    border-color: ${({ ghost }) => (ghost ? 'transparent' : '')};
  }

  width: ${({ size = FormControlSizes.Default, theme, width }) =>
    width ? parseDimension(theme, width) : `${getIconButtonSize(theme, size)}px`};
  height: ${({ size = FormControlSizes.Default, theme, height }) =>
    height ? parseDimension(theme, height) : `${getIconButtonSize(theme, size)}px`};

  font-size: ${({ theme, size }) => getIconFontSize(theme, size)}rem;
`;

export interface IconButtonWrapperProps extends ButtonWrapperProps, ButtonHTMLAttributes<HTMLButtonElement> {
  /** If target is round or square */
  round?: boolean;
}

export const IconButtonWrapper = styled(ButtonWrapper)<IconButtonWrapperProps>`
  ${iconButtonStyles}
`;
